/**
 * @param {Object} options:
 * @property {Object} stockWrapper - wrapper DOM element that we toggle the stock attr on
 * @property {String} stockWrapperAttr - the attr on the stockWrapper that is toggled with the stock value
 * @property {Object} atcButton - DOM element for the add to cart button
 * @property {String} oosAttr - attr on the atcButton that has the text for oos product
 * @property {String} inStockAttr - attr on the atcButton that has the text for the instock product
 * @property {String} unavailableAttr - attr on the atcButton that has the text for the unavailable product
 *
 * @returns {Function(availablilityFlag{Boolean}, skipAttribute{Boolean})} (impure) function that takes the availabity and updates the stock display on the page
 */

import { formatMoney } from '../../utils/currency';

const switchStockDisplay = options => (availablilityFlag, skipAttribute) => {
  const purchasable =
    availablilityFlag === 'available' || availablilityFlag === 'pre-order' || availablilityFlag === 'low';

  const {
    stockWrapper,
    stockWrapperAttr,
    atcButton,
    dummyAtcButton,
    oosAttr,
    inStockAttr,
    unavailableAttr,
    preOrderAttr,
    comingSoonAttr
  } = options;

  const atcContainer = stockWrapper.querySelector('[data-add-to-cart-container]');

  let variantPrice;
  const selectElems = stockWrapper.querySelectorAll('[data-option-select]');

  selectElems.forEach(el => {
    const price = parseFloat(el.dataset.optionPrice);
    if (el.checked && price) {
      variantPrice = price;
    }
  });

  atcButton.disabled = !purchasable;
  atcContainer ? atcContainer.classList.remove('hide') : null;

  if (!skipAttribute) {
    stockWrapper.setAttribute(stockWrapperAttr, availablilityFlag);
  }

  const inStockLabel = stockWrapper.querySelector('[data-variant-stock-display-in-stock]');
  const lowStockLabel = stockWrapper.querySelector('[data-variant-stock-display-low-stock]');
  const preOrderLabel = stockWrapper.querySelector('[data-variant-stock-display-preorder]');
  const comingSoonLabel = stockWrapper.querySelector('[data-variant-stock-display-coming-soon]');

  const backInStockFormWrapper = stockWrapper.querySelector('[data-back-in-stock]');
  const backInStockForm = backInStockFormWrapper.querySelector('[data-bis-form]');
  const backInStockFormMessages = backInStockFormWrapper.querySelector('[data-notify-message]');

  backInStockFormWrapper ? backInStockFormWrapper.classList.add('hide') : null;
  backInStockForm ? backInStockForm.classList.add('hide') : null;
  backInStockFormMessages ? backInStockFormMessages.classList.add('hide') : null;

  if (availablilityFlag === 'pre-order') {
    inStockLabel ? inStockLabel.classList.add('hide') : null;
    lowStockLabel ? lowStockLabel.classList.add('hide') : null;
    preOrderLabel ? preOrderLabel.classList.remove('hide') : null;
    comingSoonLabel ? comingSoonLabel.classList.add('hide') : null;
    backInStockFormWrapper ? backInStockFormWrapper.classList.add('hide') : null;
    backInStockForm ? backInStockForm.classList.add('hide') : null;
    atcButton.innerHTML = atcButton.getAttribute(preOrderAttr);
    dummyAtcButton
      ? (dummyAtcButton.innerHTML = `${atcButton.getAttribute(preOrderAttr)} - ${formatMoney(variantPrice, window.theme.moneyFormat)}`)
      : null;
  } else if (availablilityFlag === 'available') {
    inStockLabel ? inStockLabel.classList.remove('hide') : null;
    lowStockLabel ? lowStockLabel.classList.add('hide') : null;
    preOrderLabel ? preOrderLabel.classList.add('hide') : null;
    comingSoonLabel ? comingSoonLabel.classList.add('hide') : null;
    backInStockFormWrapper ? backInStockFormWrapper.classList.add('hide') : null;
    backInStockForm ? backInStockForm.classList.add('hide') : null;
    atcButton.innerHTML = atcButton.getAttribute(inStockAttr);
    dummyAtcButton
      ? (dummyAtcButton.innerHTML = `${atcButton.getAttribute(inStockAttr).split(' ')[0]} - ${formatMoney(variantPrice, window.theme.moneyFormat)}`)
      : null;
  } else if (availablilityFlag === 'low') {
    inStockLabel ? inStockLabel.classList.add('hide') : null;
    lowStockLabel ? lowStockLabel.classList.remove('hide') : null;
    preOrderLabel ? preOrderLabel.classList.add('hide') : null;
    comingSoonLabel ? comingSoonLabel.classList.add('hide') : null;
    backInStockFormWrapper ? backInStockFormWrapper.classList.add('hide') : null;
    backInStockForm ? backInStockForm.classList.add('hide') : null;
    atcButton.innerHTML = atcButton.getAttribute(inStockAttr);
    dummyAtcButton
      ? (dummyAtcButton.innerHTML = `${atcButton.getAttribute(inStockAttr).split(' ')[0]} - ${formatMoney(variantPrice, window.theme.moneyFormat)}`)
      : null;
  } else if (availablilityFlag === 'coming-soon') {
    inStockLabel ? inStockLabel.classList.add('hide') : null;
    lowStockLabel ? lowStockLabel.classList.add('hide') : null;
    preOrderLabel ? preOrderLabel.classList.add('hide') : null;
    comingSoonLabel ? comingSoonLabel.classList.remove('hide') : null;
    backInStockFormWrapper ? backInStockFormWrapper.classList.remove('hide') : null;
    backInStockForm ? backInStockForm.classList.remove('hide') : null;
    atcContainer ? atcContainer.classList.add('hide') : null;
    atcButton.innerHTML = atcButton.getAttribute(comingSoonAttr);
    dummyAtcButton ? (dummyAtcButton.innerHTML = atcButton.getAttribute(comingSoonAttr)) : null;
  } else if (availablilityFlag === 'oos') {
    inStockLabel ? inStockLabel.classList.add('hide') : null;
    lowStockLabel ? lowStockLabel.classList.add('hide') : null;
    preOrderLabel ? preOrderLabel.classList.add('hide') : null;
    comingSoonLabel ? comingSoonLabel.classList.add('hide') : null;
    backInStockFormWrapper ? backInStockFormWrapper.classList.remove('hide') : null;
    backInStockForm ? backInStockForm.classList.remove('hide') : null;
    atcContainer ? atcContainer.classList.add('hide') : null;
    atcButton.innerHTML = atcButton.getAttribute(oosAttr);
    dummyAtcButton ? (dummyAtcButton.innerHTML = atcButton.getAttribute(oosAttr)) : null;
  } else {
    inStockLabel ? inStockLabel.classList.add('hide') : null;
    lowStockLabel ? lowStockLabel.classList.add('hide') : null;
    backInStockFormWrapper ? backInStockFormWrapper.classList.add('hide') : null;
    backInStockForm ? backInStockForm.classList.add('hide') : null;
    atcButton.innerHTML = atcButton.getAttribute(unavailableAttr);
    dummyAtcButton ? (dummyAtcButton.innerHTML = atcButton.getAttribute(unavailableAttr)) : null;
  }

  // Always show ATC on co-ords
  if (stockWrapper.closest('.product-form-co-ord__wrapper')) {
    atcButton ? atcButton.classList.remove('hide') : null;
  }
};
export default switchStockDisplay;
